export default function MahasiswaUserManual() {
  return (
    <div className="mt-2">
      <div>
        <span className="font-bold">Mahasiswa:</span>{" "}
        <a
          href={require("../../assets/user_manuals/User_Manual_Mahasiswa_v1.0.0.pdf")}
          download={"User_Manual_Mahasiswa_v1.0.0.pdf"}
          className="text-blue-500 hover:underline"
        >
          User_Manual_Mahasiswa_v1.0.0.pdf
        </a>
      </div>
    </div>
  );
}
